

























































import Component from 'vue-class-component';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ticketsDashboard } from '@/modules/shared/shared/store/namespaces';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
})
export default class TicketsReviewDot extends Vue {
    portalMonthTicketsLoaded: boolean = false;
    portalMonthChartCategories: string[] = [];
    portalMonthChartSeries: number[] = [];

    @ticketsDashboard.State('tickets') tickets;

    getTicketName(id: number) {
        switch (id) {
            case Tickets.REQUIREMENT.id:
                return 'Requerimiento';
            case Tickets.ACCESS.id:
                return 'Acceso al Data Center';
        }
        return 'Incidente';
    }

    get isLoading(): boolean {
        return !this.tickets;
    }

    get chartType(): string {
        return 'donut';
    }

    get ticketsReviewOptions(): object {
        const fontFamily = 'Roboto, sans-serif';

        return {
            chart: {
                type: this.chartType,
                fontFamily,
            },
            labels: ['Acceso', 'Incidente', 'Requerimiento'],
            dataLabels: {
                enabled: false,
            },
            colors: ['#0054a6', '#60bb46', '#f26935'],
            tooltip: {
                fillSeriesColor: false,
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        size: '60%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '1.5rem',
                                fontWeight: 500,
                                color: '#242322',
                                formatter: function(val: string) {
                                    return val && val !== null ? val.toUpperCase() : val;
                                },
                            },
                            value: {
                                show: true,
                                fontSize: '1.3rem',
                                fontWeight: 500,
                                color: '#242322',
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                label: 'Total',
                                fontSize: '.85rem',
                                fontWeight: 500,
                                color: '#242322',
                                formatter: function(val) {
                                    let total: number = 0;

                                    if (val.config.series) {
                                        val.config.series.forEach(element => {
                                            total += element;
                                        });
                                    }

                                    return total;
                                },
                            },
                        },
                    },
                },
            },
            legend: {
                show: false,
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    type: 'diagonal2',
                    gradientToColors: ['#8dd8f8', '#60bb46', '#de9e84'],
                    stops: [0, 100],
                },
            },
            stroke: {
                colors: ['#0054a6', '#60bb46', '#f26935'],
                width: 2,
            },
            states: {
                active: {
                    filter: {
                        type: 'none',
                    },
                },
            },
        };
    }

    get portalMonthTickets() {
        const portalMonthTickets: {}[] = [];
        const currentMonth: number = new Date().getMonth() + 1;
        let accessTickets: boolean = false;
        let requirementTickets: boolean = false;
        let incidentTicket: boolean = false;
        if (
            this.tickets &&
            this.tickets.values.portalMonthTickets !== undefined &&
            this.tickets.values.portalMonthTickets.length > 0
        ) {
            this.tickets.values.portalMonthTickets.forEach(ticketTypeRecord => {
                if (ticketTypeRecord.month == currentMonth) {
                    let text: string = '';

                    switch (ticketTypeRecord.ticketType) {
                        case 7:
                            accessTickets = true;
                            break;
                        case 1:
                            requirementTickets = true;
                            break;
                        case 2:
                            incidentTicket = true;
                        default:
                            break;
                    }

                    const lastMonthValue = this.tickets.values.portalMonthTickets.find(
                        element =>
                            element.ticketType == ticketTypeRecord.ticketType &&
                            element.month == currentMonth - 1,
                    );

                    if (!lastMonthValue) {
                        text = `${ticketTypeRecord.total} ${
                            ticketTypeRecord.total > 0 ? 'más' : 'menos'
                        } que el mes anterior`;
                    } else {
                        text = `${Math.abs(ticketTypeRecord.total - lastMonthValue.total)} ${
                            ticketTypeRecord.total - lastMonthValue.total > 0 ? 'más' : 'menos'
                        } que el mes anterior`;
                    }

                    portalMonthTickets.push({
                        id: ticketTypeRecord.ticketType,
                        total: ticketTypeRecord.total,
                        subtractionText: text,
                    });

                    if (ticketTypeRecord.ticketType === Tickets.REQUIREMENT.id) {
                        this.portalMonthChartCategories.push('Requerimiento');
                    } else if (ticketTypeRecord.ticketType === Tickets.ACCESS.id) {
                        this.portalMonthChartCategories.push('Acceso');
                    } else {
                        this.portalMonthChartCategories.push('Incidente');
                    }

                    this.portalMonthChartSeries.push(parseInt(ticketTypeRecord.total));
                } else if (
                    (ticketTypeRecord.ticketType === Tickets.REQUIREMENT.id &&
                        !requirementTickets) ||
                    (ticketTypeRecord.ticketType === Tickets.ACCESS.id && !accessTickets) ||
                    (ticketTypeRecord.ticketType === Tickets.INCIDENT.id && !incidentTicket)
                ) {
                    const currentMonthValue = this.tickets.values.portalMonthTickets.find(
                        element =>
                            element.ticketType == ticketTypeRecord.ticketType &&
                            element.month == currentMonth,
                    );

                    if (!currentMonthValue) {
                        let text: string = '';
                        text = `${ticketTypeRecord.total} ${
                            ticketTypeRecord.total > 0 ? 'más' : 'menos'
                        } que el mes anterior`;

                        portalMonthTickets.push({
                            id: ticketTypeRecord.ticketType,
                            total: ticketTypeRecord.total,
                            subtractionText: text,
                        });
                    }
                }
            });
            this.portalMonthTicketsLoaded = true;

            return portalMonthTickets;
        } else {
            this.portalMonthTicketsLoaded = false;

            portalMonthTickets.push({
                id: Tickets.ACCESS.id,
                total: 0,
                subtractionText: '0 desde el mes anterior',
            });

            portalMonthTickets.push({
                id: Tickets.REQUIREMENT.id,
                total: 0,
                subtractionText: '0 desde el mes anterior',
            });

            portalMonthTickets.push({
                id: Tickets.INCIDENT.id,
                total: 0,
                subtractionText: '0 desde el mes anterior',
            });

            return portalMonthTickets;
        }
    }
}
